import {
    createRouter,
    createWebHistory
} from "vue-router";
import ResetPasswordView from '../views/ResetPasswordView.vue'

const routes = [{
    path: "/reset-password",
    name: "reset",
    component: ResetPasswordView
}, ]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;